import {Component, Inject, Optional} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';
import {MatTableDataSource} from '@angular/material/table';
import {ActivatedRoute, Router} from "@angular/router";
import {EnumStudioType, ISceneTemplateImport, IUser, loginUrlType} from "../../../interfaces";
import {AuthUserService, LocalStoreService, StoreSelectorsService} from "../../../services";
import {compareIds, isHostDevOrLocal, popupWindow} from "../../../common";
import {Compbaser} from "../../../components/compbaser";
import {DialogAssetViewerComponent, IDialogAssetViewer} from "../dialog-asset-viewer/dialog-asset-viewer.component";

@Component({
    selector: 'app-started-lists',
    templateUrl: './started-lists.component.html',
    styleUrls: ['./started-lists.component.scss']
})
export class StartedListsComponent extends Compbaser {
    displayedColumns = ['color', 'name', 'id'];
    dataSource: MatTableDataSource<ISceneTemplateImport>;
    dialogMode = false;
    selectedStudioType = 'Sign Studio';
    selectedGroup = 'all';
    callBack;
    sceneTemplates: ISceneTemplateImport[];

    // @ViewChild(MatSort, {static: false}) sort: MatSort;

    studioType: EnumStudioType;
    mode: loginUrlType;
    filtering = false;
    enterprise = false;
    openWidth = 480;
    openHeight = 270;

    constructor(private router: Router,
                private route: ActivatedRoute,
                private storeSelector: StoreSelectorsService,
                private authUserService: AuthUserService,
                private localStore: LocalStoreService,
                protected override dialog: MatDialog, @Optional() @Inject(MAT_DIALOG_DATA) data: any) {
        super();
        if (data) {
            this.dialogMode = true;
            this.callBack = data.callBack;
        }
        this.cod(
            this.storeSelector.getUser()
                .subscribe((i_user: IUser) => {
                    this.enterprise = i_user.enterprise;
                })
        );
        this.cod(
            this.storeSelector.getLocalStoreUpdates()
                .subscribe((updates) => {
                    this.studioType = this.localStore.getStorageConfig().socialUserPendingStudioType;
                })
        );
        this.cod(
            this.route.paramMap.subscribe((routeParams) => {
                // this.studioType = routeParams.get('id');
                this.mode = routeParams.get('mode') as loginUrlType;
                // if (this.studioType === null) return;
                // this.getSampleList();
            })
        );
        this.cod(
            this.storeSelector.listenSceneImports()
                .subscribe((i_sceneTemplates: ISceneTemplateImport[]) => {
                    this.sceneTemplates = i_sceneTemplates;
                    if (this.dialogMode) {
                        this.filterByStudio('Sign Studio');
                        return;
                    }
                    this.sceneTemplates = i_sceneTemplates.filter((v) => {
                        switch (this.studioType) {
                            case EnumStudioType.SIGN_STUDIO:
                            case EnumStudioType.PRO: {
                                return compareIds(v.studioType, this.studioType);
                            }
                            case EnumStudioType.LITE: {
                                return false;
                            }
                        }
                    });
                    this.dataSource = new MatTableDataSource(this.sceneTemplates);
                })
        );
    }

    goBack() {
        this.authUserService.backToLogin();
    }

    openDialogPreview(event, row, studioType: EnumStudioType): void {
        event.stopImmediatePropagation();
        event.preventDefault();
        if (row.name === 'Empty account') return;
        switch (row.category) {
            case 'Playlist': {
                if (isHostDevOrLocal()) {
                    popupWindow({url: row.video.replace('galaxy', 'dev'), title: '_blank', w: this.openWidth, h: this.openHeight}, 'no', 'yes');
                } else {
                    popupWindow({url: row.video, title: '_blank', w: this.openWidth, h: this.openHeight}, 'no', 'yes');
                }
                break;
            }
            case 'Interactive': {
                if (isHostDevOrLocal()) {
                    popupWindow({url: row.video.replace('galaxy', 'dev'), title: '_blank', w: this.openWidth, h: this.openHeight}, 'no', 'yes');
                } else {
                    popupWindow({url: row.video, title: '_blank', w: this.openWidth, h: this.openHeight}, 'no', 'yes');
                }
                break;
            }
            case 'preview': {
                let videos = [];
                let images = [];
                if (studioType == EnumStudioType.PRO) {
                    videos = [row.video];
                } else {
                    images = row.snaps;
                }
                const data: IDialogAssetViewer = {
                    videos,
                    images,
                    autoMoveNext: false,
                    autoMoveNextTime: 1,
                };
                const dialogRef = this.dialog.open(DialogAssetViewerComponent, {
                    height: '550px',
                    width: '800px',
                    data
                });
                this.cod(
                    dialogRef.afterClosed().subscribe(result => {
                        // console.log('The dialog was closed ' + result);
                    })
                );
                break;
            }
            default: {
                if (isHostDevOrLocal()) {
                    popupWindow({url: row.video.replace('galaxy', 'dev'), title: '_blank', w: this.openWidth, h: this.openHeight}, 'no', 'yes');
                } else {
                    popupWindow({url: row.video, title: '_blank', w: this.openWidth, h: this.openHeight}, 'no', 'yes');
                }
            }
        }
    }

    onSelection(row) {
        this.localStore.setStorageValConfig('socialUserPendingTemplateId', row.templateBusinessId);
        if (this.callBack) return this.callBack(row.templateBusinessId);
        if (this.mode) {
            this.router.navigateByUrl(`getstarted/create/${this.mode}`);
        } else {
            this.router.navigateByUrl(`getstarted/create`);
        }
    }

    filterByStudio(event) {
        this.selectedStudioType = event.value ? event.value : event;
        switch (this.selectedStudioType) {
            case 'All': {
                this.dataSource = new MatTableDataSource(this.sceneTemplates);
                return;
            }
            case 'Sign Studio': {
                event = EnumStudioType.SIGN_STUDIO;
                break;
            }
            case 'Legacy Studio': {
                event = EnumStudioType.PRO;
                break;
            }
        }
        const scenes = this.sceneTemplates.filter((i_sceneTemplate) => compareIds(i_sceneTemplate.studioType, event));
        this.dataSource = new MatTableDataSource(scenes);
    }

    filterByTouch(event) {
        this.filtering = true;
        this.selectedGroup = event.value ? event.value : event;
        let isTouch = false;
        setTimeout(() => {
            this.filtering = false;
        }, 400);

        switch (this.selectedGroup) {
            case 'all': {
                this.dataSource.data = this.sceneTemplates;
                return;
            }
            case 'signage': {
                isTouch = false;
                break;
            }
            case 'touch': {
                isTouch = true;
                break;
            }
        }

        const scenes = this.sceneTemplates.filter((i_sceneTemplate) => i_sceneTemplate.touch === isTouch);
        this.dataSource.data = scenes;
    }

    applyFilter(filterValue: string) {
        filterValue = filterValue.trim();
        filterValue = filterValue.toLowerCase();
        this.dataSource.filter = filterValue;
    }

    // getSampleList() {
    //     this.storeSelectors.appStore.dispatch(actionLoadTemplateRequest({}));
    // }
}


